"use client";import{jsxs as e,jsx as t}from"react/jsx-runtime";import{useState as a,useEffect as r}from"react";import{twMerge as s}from"tailwind-merge";import{SystemIcon as n}from"../../DataDisplays/SystemIcon/SystemIcon.js";import"../../DataDisplays/SystemIcon/SystemIcon.constants.js";import{Typography as o}from"../../Base/Typography/Typography.js";import{Box as i}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import{TextFieldContainer as l}from"../TextFieldContainer/TextFieldContainer.js";import{SelectHeader as d,WeekHeader as c,DateBox as m}from"./Calendar.parts.js";import{generateDate as p,today as y,getKoreanTimeString as g,getMonthDate as h,isSameDate as x}from"./Calendar.utils.js";
/**
 * 날짜를 선택할 수 있는 캘린더 컴포넌트입니다.
 *
 * @component

 *
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {string} [props.selected] - 선택된 날짜 (YYYY-MM-DD 형식)
 * @param {(date: string) => void} [props.onChange] - 날짜 선택 시 호출되는 콜백 함수, YYYY-MM-DD 형식의 인자를 받음
 * @param {string} [props.defaultDate] - 초기 기본 날짜 (YYYY-MM-DD 형식)
 * @param {boolean} [props.disabled] - 캘린더 비활성화 여부
 * @param {string} [props.placeholder] - 날짜가 선택되지 않았을 때 표시될 텍스트
 * @param {boolean} [props.isError] - 에러 상태 표시 여부
 *
 * @example
 * ```tsx
 * // 기본 사용법
 * <Calendar
 *   selected="2024-03-21"
 *   onChange={(date) => console.log(date)}
 *   placeholder="날짜를 선택하세요"
 * />
 *
 * // 비활성화된 상태
 * <Calendar
 *   disabled={true}
 *   placeholder="선택 불가"
 * />
 *
 * // 에러 상태
 * <Calendar
 *   isError={true}
 *   selected="2024-03-21"
 * />
 * ```
 */const u=({defaultDate:u,selected:f,onChange:w,disabled:b,placeholder:j,isError:C})=>{const[$,B]=a(!1),D=()=>{b||B((e=>!e))},N=u?p(u):y,[F,I]=a(f?p(f):N),v=f?p(f):N,{year:S,month:T,date:L}=g(v),{dateList:k}=h(F.year,F.month),z=[...Array.from({length:k[0].day},(()=>null)),...k],E=e=>{if(f&&x(e,v))return;const t=`${e.year}-${e.month}-${e.date}`;null==w||w(t),B(!1)};return r((()=>{!$&&f&&I(p(f));
// eslint-disable-next-line react-hooks/exhaustive-deps
}),[$]),/*#__PURE__*/e(i,{className:"relative h-fit w-fit select-none","data-testid":"design-system-calendar--container",children:[
/*#__PURE__*/t(i,{className:"cursor-pointer",children:/*#__PURE__*/e(l,{isFocused:$,isError:C,isDisabled:b,testId:"design-system-calendar--trigger",onClick:D,children:[
/*#__PURE__*/t(n,{name:"medium_calendar",className:b||!f?"text-w-gray-300":"text-w-gray-400"}),
/*#__PURE__*/t(o,{variant:"body1",className:s("min-w-[178px] text-w-gray-600",!f&&"text-w-gray-300",b&&"text-w-gray-300"),"data-testid":"design-system-calendar--selected-date",children:f?`${S} ${T} ${L}`:j})]})}),$&&/*#__PURE__*/t("div",{className:"fixed left-0 top-0 z-10 h-screen w-screen bg-transparent",onClick:D}),$&&/*#__PURE__*/e(i,{"data-testid":"design-system-calendar--content",className:"absolute top-[54px] z-30 flex w-[350px] flex-col gap-4 rounded-xl border border-w-gray-200 bg-w-white px-[15px] py-[23px] shadow-graymedium",children:[
/*#__PURE__*/t(d,{visibleDate:F,onChange:e=>{I(e)}}),
/*#__PURE__*/t(c,{}),
/*#__PURE__*/t(i,{className:"grid w-full grid-cols-7 place-content-center place-items-center gap-1",children:z.map(((e,a)=>{const r=!(!e||!f)&&x(e,v);return e?/*#__PURE__*/t(m,{date:e,selected:r,onChange:E},`${e.year}-${e.month}-${e.date}`):/*#__PURE__*/t(m,{disabled:!0},a)}))})]})]})};export{u as Calendar};
